import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const PhoneValidation = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const matches: boolean = RegExp(
      /^\((?!(800|866|877|855|0{3}|1{3}|2{3}|3{3}|4{3}|5{3}|6{3}|7{3}|8{3}|9{3}))(\d{3})\)\s(?!(555))(\d{3})\-(\d{4})$/,
    ).test(control.value);

    return matches ? null : { invalidPhoneNumber: { value: control.value } };
  };
};
